exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sgControls-c0da44d8{display:flex;padding:5px 10px;font-size:13px}.sgControls-c0da44d8 .pullRight-9e3780ea{margin-left:auto}.hint-9839e736{color:#9E9E9E}.savePrompt-706c2950{display:inline-block}.savePrompt-706c2950+span{margin-left:16px}\n", ""]);

// Exports
exports.locals = {
	"sgControls": "sgControls-c0da44d8",
	"pullRight": "pullRight-9e3780ea",
	"hint": "hint-9839e736",
	"savePrompt": "savePrompt-706c2950"
};